export enum TestRecordExportEnum {
  CSV = "csv",
  EXCEL = "excel",
}

export enum FileExtensionEnum {
  EXCEL = ".xlsx",
  CSV = ".csv",
}
